import { Box, createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import _ from 'lodash';
import React from 'react';
import { ColorPalette } from '../../../../pages/AnalysisPage/Palette/ColorPalette';
import { TopKeywordsCellItem } from './TopKeywordsCellItem';

export interface TopKeywordsTableProps {
  chartData: any[];
  showRanks?: boolean;
  limitItems: number;
  palette: ColorPalette;
}
export const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    numberedCell: {
      width: '30px',
    },
  })
);

export const TopKeywordsTable: React.FC<TopKeywordsTableProps> = ({
  chartData,
  showRanks,
  limitItems,
  palette,
}) => {
  const rows: number[] = _.range(0, limitItems, 1);

  const classes = useClasses();
  return (
    <Box pt={2}>
      <Grid container direction={'row'} wrap={'nowrap'}>
        <Grid item className={classes.numberedCell}>
          <Box textAlign={'right'} mr={4} color={'transparent'}>
            0
          </Box>
        </Grid>
        {chartData.map((tg, index) => (
          <Grid item xs zeroMinWidth key={index}>
            <Typography variant={'body2'} align={'center'} noWrap gutterBottom>
              {tg.name}
            </Typography>
          </Grid>
        ))}
      </Grid>

      {rows.map((rowIndex) => (
        <Grid container direction={'row'} wrap={'nowrap'} alignItems={'center'} key={rowIndex}>
          <Grid item className={classes.numberedCell}>
            <Box textAlign={'right'} mr={4}>
              {rowIndex + 1}
            </Box>
          </Grid>
          {chartData.map((tg, index) => (
            <Grid item xs key={index} zeroMinWidth>
              <TopKeywordsCellItem
                keyword={tg.keywords[rowIndex]?.name}
                volume={tg.keywords[rowIndex]?.volume}
                rank={tg.keywords[rowIndex]?.rank}
                showRanks={showRanks}
                palette={palette}
              />
            </Grid>
          ))}
        </Grid>
      ))}
    </Box>
  );
};

export default TopKeywordsTable;
